import Grid from "@mui/material/Grid";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../../assets/colors";
import JobWorthCalculatorSvg from "../../../../assets/svg/jwc-icon-mobile.svg";
import WorkPersonaIcon from "../../../../assets/svg/wpt-icon-mobile.svg";

export const ImageStyled = styling("img")({
  width: "100%",
  height: "100%",
  borderRadius: "0.625rem",
  objectFit: "contain",
  border: "1.5px solid #000",
});

export const ImageContainer = styling(Grid)((props) => ({
  backgroundColor:
    props?.type == "workPersona"
      ? Color.hiredlyPurple
      : props?.type == "jobCalculator"
      ? "#FF6F61"
      : Color.white,
  transitionDuration: "0.5s",
  transform: props.transform,
  height: "100px",
  width: "100px",
  margin: "8.73px 8.06px 8.06px 8.73px",
  opacity: props.opacity,
  borderRadius: "0.625rem",
  border:
    (props?.type == "workPersona" || props?.type == "jobCalculator") &&
    "1.5px solid #000",
  zIndex: 1,
  right: props.right,
  position: "relative",

  ":hover": {
    cursor: "none",
  },

  [props.theme.breakpoints.down("lg")]: {
    transitionDuration: "2.5s",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "77.2px !important",
    width: "77.2px !important",
  },
}));

export const CustomTooltip = styling(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: "20px",
    padding: "5px",
    border: "3px solid black",
    backgroundColor: Color.white,
    color: "black",
    zIndex: 5,
    cursor: "none",
  },
});

export const LinkStyled = styling("a")((props) => ({
  pointerEvents: props["aria-disabled"] ? "none" : "auto",
}));

// Icon Components //
export const WPTIcon = styling(WorkPersonaIcon)({});
export const JWCIcon = styling(JobWorthCalculatorSvg)({});
